import { render, staticRenderFns } from "./JustificaionDetailsModal.vue?vue&type=template&id=26bf49ce&"
import script from "./JustificaionDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./JustificaionDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports